/**
 * Box 1 (spec §3.2): "เรียงตาม" Spend / Cost per Result / CTR and "Format" ทั้งหมด / Static / Video / Carousel / อื่น ๆ.
 * Both live in the URL only (spec §4.6) and read nothing: the page sorts and filters on the client, so neither waits
 * for a read. Styled like the filter band above it, and printed as drawn (R20), so a PDF says how its table was sorted
 * and filtered. A plain box, not a landmark: each select names itself, and the box is kept whole on paper.
 *
 * @module components/creatives/CreativeControls
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LOOKER_FIELD_CLASS, LOOKER_LABEL_CLASS } from '@/components/looker/LookerFilterBar';
import { formatFilterLabel, sortLabel } from '@/services/creatives/creativeText';
import { CREATIVE_SORTS, FORMAT_FILTERS, type CreativeSort, type FormatFilter } from '@/services/creatives/creativeTypes';

interface Props {
  sort: CreativeSort;
  onSort: (sort: CreativeSort) => void;
  format: FormatFilter;
  onFormat: (format: FormatFilter) => void;
}

export const CreativeControls: React.FC<Props> = ({ sort, onSort, format, onFormat }) => {
  const { t } = useTranslation();
  return (
    <div data-overview-box="1"
      className="flex flex-wrap items-end gap-3 break-inside-avoid rounded-2xl border border-neutral-200 bg-white p-4 shadow-sm">
      <label className={LOOKER_LABEL_CLASS}>
        {t('creatives.sort.label')}
        <select
          aria-label={t('creatives.sort.label')} className={LOOKER_FIELD_CLASS} value={sort}
          onChange={(e) => onSort(CREATIVE_SORTS.find((s) => s === e.target.value) ?? 'spend')}
        >
          {CREATIVE_SORTS.map((s) => <option key={s} value={s}>{sortLabel(s, t)}</option>)}
        </select>
      </label>
      <label className={LOOKER_LABEL_CLASS}>
        {t('creatives.format.label')}
        <select
          aria-label={t('creatives.format.label')} className={LOOKER_FIELD_CLASS} value={format}
          onChange={(e) => onFormat(FORMAT_FILTERS.find((f) => f === e.target.value) ?? 'all')}
        >
          {FORMAT_FILTERS.map((f) => <option key={f} value={f}>{formatFilterLabel(f, t)}</option>)}
        </select>
      </label>
    </div>
  );
};
